export function weekday(date) {
  const newDate = new Date(date);
  return newDate.getDay();
}
